angular.module('autoremind.admin.chargify')
    // Adding Directive keyword for mangle=true
    .directive('adminChargifyMessageBilling', ['$rootScope', 'chargifyService', 'logger', function ($rootScope, chargifyService, logger) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/chargify/admin-chargify-message-billing.html',
            scope: {},
            link: function ($scope, element, attrs) {
                $scope.showCountEmail = false;
                $scope.showSumFree = false;
                $scope.showCountSMS = false;
                $scope.showCountVoice = false;
                $scope.showSumBilling = true;
                $scope.showActiveSubscription = false;
                $scope.messageCountFetchStateBusy = false;
                $scope.messageCount = [];
                $scope.messageCountBaseURL = "";
                $scope.messageCountCustomerCount = null;
                $scope.messageCountSort = { "column": "updatedInt", "descending": false };
                $scope.editAccountListStateBusy = false;
                $scope.keepLoading = false;
                $scope.getMonth = function (displacementMonths) {
                    var date = new Date();
                    date.setMonth(date.getMonth() + displacementMonths);
                    if (date.getMonth() >= 9) {
                        return date.getFullYear() + "-" + (date.getMonth() + 1);
                    }
                    else {
                        return date.getFullYear() + "-0" + (date.getMonth() + 1);
                    }
                };
                $scope.messageCountMonth = $scope.getMonth(0);
                $scope.messageCountPrevMonth = $scope.getMonth(-1);
                $scope.changeSortingMessageCount = function (column) {
                    if (column === "actionInit") {
                        $scope.reorderInitAction();
                    }
                    if ($scope.messageCountSort.column === column) {
                        $scope.messageCountSort.descending = !$scope.messageCountSort.descending;
                    }
                    else {
                        $scope.messageCountSort.column = column;
                        $scope.messageCountSort.descending = false;
                    }
                };
                $scope.showChangeTier = function (account) {
                    account.showChangeTier = !account.showChangeTier;
                };
                $scope.fetchMessageCount = function () {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchBillingMessageCount() start');
                    $scope.messageCountFetchStateBusy = true;
                    $scope.messageCount = [];
                    $scope.messageCountCustomerCount = null;
                    chargifyService.fetchBillingMessageCount($scope.messageCountPrevMonth, $scope.messageCountMonth)
                        .then(function (data, status) {
                        $scope.messageCount = data.messageCount;
                        $scope.messageCountMonth = data.month;
                        $scope.messageCountPrevMonth = data.prevMonth;
                        $scope.messageCountCustomerCount = data.customersCount;
                        $scope.messageCountFetchStateBusy = false;
                        if ($scope.messageCount.length > 0) {
                            $scope.reorderInitAction();
                            $scope.keepLoading = true;
                            $scope.fetchNextSingleAccount();
                        }
                    }, function (data, status) {
                        $scope.status = status;
                        $scope.messageCountFetchStateBusy = false;
                    });
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchBillingMessageCount() end');
                };
                $scope.reorderInitAction = function () {
                    if ($scope.messageCount.length > 0) {
                        for (var i = 0; i < $scope.messageCount.length; i++) {
                            $scope.messageCount[i].actionInit = $scope.messageCount[i].action + " " + $scope.messageCount[i].paymentUserName;
                        }
                    }
                };
                $scope.fetchNextSingleAccount = function () {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchNextSingleAccount() start');
                    var isLoading = false;
                    for (var i = 0; i < $scope.messageCount.length; i++) {
                        if ($scope.messageCount[i].action === "Loading") {
                            isLoading = true;
                        }
                        else if (isLoading === false && $scope.keepLoading &&
                            ($scope.messageCount[i].action === undefined || $scope.messageCount[i].action === null || $scope.messageCount[i].action === "reload")) {
                            $scope.messageCount[i].action = "Loading";
                            $scope.fetchMessageCountSingleAccount($scope.messageCount[i].paymentUserName);
                            isLoading = true;
                        }
                        else {
                            //      $scope.messageCount[i].action = "Loading";
                        }
                    }
                };
                $scope.updateMessageCountArray = function (newArray) {
                    logger.debug('autoremind.admin.chargify.ScreenController.updateMessageCountArray(' + newArray.length + ') start');
                    for (var i = 0; i < newArray.length; i++) {
                        var isUpdated = false;
                        for (var j = 0; j < $scope.messageCount.length; j++) {
                            if (newArray[i].paymentUserName === $scope.messageCount[j].paymentUserName) {
                                newArray[i].actionInit = $scope.messageCount[j].actionInit;
                                $scope.messageCount[j] = newArray[i];
                                isUpdated = true;
                                break;
                            }
                        }
                        if (isUpdated === false) {
                            newArray[i].actionInit = newArray[i].action + " " + newArray[i].paymentUserName;
                            $scope.messageCount[$scope.messageCount.length] = newArray[i];
                        }
                    }
                };
                $scope.fetchMessageCountSingleAccount = function (paymentUserName) {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchMessageCountSingleAccount(' + paymentUserName + ') start');
                    $scope.messageCountFetchStateBusy = true;
                    // $scope.messageCountCustomerCount = null;
                    chargifyService.fetchBillingMessageCountSingleAccount($scope.messageCountPrevMonth, $scope.messageCountMonth, paymentUserName)
                        .then(function (data, status) {
                        if (data.messageCount != null && data.messageCount.length > 0) {
                            $scope.updateMessageCountArray(data.messageCount);
                        }
                        $scope.messageCountFetchStateBusy = false;
                        $scope.fetchNextSingleAccount();
                    }, function (data, status) {
                        $scope.status = status;
                        $scope.messageCountFetchStateBusy = false;
                    });
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchMessageCountSingleAccount(' + paymentUserName + ') end');
                };
                $scope.reloadAccount = function (account) {
                    logger.debug('autoremind.admin.chargify.ScreenController.reloadAccount(' + account.paymentUserName + ')');
                    account.action = "reload";
                    $scope.keepLoading = true;
                    $scope.fetchNextSingleAccount();
                };
                $scope.updateSubscriptionTier = function (account, newTier) {
                    logger.debug('autoremind.admin.chargify.ScreenController.updateSubscriptionTier() start');
                    account.updateSubscriptionBusy = true;
                    account.action = "Updating";
                    var updateJSON = { "newTierName": newTier };
                    chargifyService.updateSubscriptionTier(account.paymentUserName, account.chargifySubscription.id, updateJSON)
                        .then(function (data, status) {
                        if (data.paymentUserName && data.chargifySubscriptionId) {
                            for (var i = 0; i < $scope.messageCount.length; i++) {
                                if (data.paymentUserName === $scope.messageCount[i].paymentUserName
                                    && data.chargifySubscriptionId === $scope.messageCount[i].chargifySubscription.id) {
                                    $scope.messageCount[i].action = data.action;
                                    $scope.messageCount[i].enabledMessageTierName = data.enabledMessageTierName;
                                    $scope.messageCount[i].updateSubscriptionBusy = false;
                                }
                            }
                        }
                    }, function (data, status) {
                        $scope.status = status;
                    });
                    logger.debug('autoremind.admin.chargify.ScreenController.updateSubscriptionTier() end');
                };
                $scope.chargeAccount = function (account, newTier) {
                    logger.debug('autoremind.admin.chargify.ScreenController.chargeAccount(' + account.paymentUserName + ') start');
                    account.updateSubscriptionBusy = true;
                    account.action = "Updating";
                    var updateJSON = {
                        "paymentUserName": account.paymentUserName,
                        "chargifySubscriptionId": account.chargifySubscription.id,
                        "price": account.price,
                        "charged": account.charged
                    };
                    chargifyService.chargeAccount(account.paymentUserId, updateJSON)
                        .then(function (data, status) {
                        if (data.paymentUserName && data.chargifySubscriptionId) {
                            for (var i = 0; i < $scope.messageCount.length; i++) {
                                if (data.paymentUserName === $scope.messageCount[i].paymentUserName
                                    && data.chargifySubscriptionId === $scope.messageCount[i].chargifySubscription.id) {
                                    $scope.messageCount[i].action = data.action;
                                    $scope.messageCount[i].msgAction = data.msgAction;
                                    if (data.chargifyActiveSubscriptions) {
                                        $scope.messageCount[i].chargifyActiveSubscriptions = data.chargifyActiveSubscriptions;
                                    }
                                    if (data.enabledMessageTierName) {
                                        $scope.messageCount[i].enabledMessageTierName = data.enabledMessageTierName;
                                    }
                                    $scope.messageCount[i].updateSubscriptionBusy = false;
                                }
                            }
                        }
                    }, function (data, status) {
                        $scope.status = status;
                    });
                    logger.debug('autoremind.admin.chargify.ScreenController.chargeAccount(' + account.paymentUserName + ') end');
                };
                $scope.fetchAccount = function (userName) {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchAccount(' + userName + ') start');
                    $scope.editAccountListStateBusy = true;
                    for (var i = 0; i < $scope.editAccountList.length; i++) {
                        $scope.editAccountList[i].show = false;
                    }
                    if ($scope.products.length === 0) {
                        $scope.fetchProductList();
                    }
                    if ($scope.accountIsChanged(userName) === false) {
                        chargifyService.fetchAccount(userName)
                            .then(function (data, status) {
                            if (data.account != null && data.account.userName != null) {
                                if (data.account.subscription != null
                                    && data.account.subscription.product != null
                                    && data.account.subscription.product.product_family != null
                                    && data.account.subscription.product.product_family.handle != null) {
                                    data.account.producthandle = data.account.subscription.product.product_family.handle;
                                }
                                var isUpdated = false;
                                for (var i = 0; i < $scope.editAccountList.length; i++) {
                                    if ($scope.editAccountList[i].userName === data.account.userName) {
                                        if ($scope.editAccountList[i].changed !== true) {
                                            $scope.findHasOwnSubscription(data.account);
                                            $scope.editAccountList[i] = data.account;
                                        }
                                        $scope.editAccountList[i].show = true;
                                        isUpdated = true;
                                    }
                                    else {
                                        $scope.editAccountList[i].show = false;
                                    }
                                }
                                if (isUpdated === false) {
                                    data.account.changed = false;
                                    data.account.show = true;
                                    $scope.findHasOwnSubscription(data.account);
                                    $scope.editAccountList.push(data.account);
                                }
                            }
                            $scope.editAccountListStateBusy = false;
                        }, function (data, status) {
                            $scope.status = status;
                        });
                    }
                    else {
                        for (var i = 0; i < $scope.editAccountList.length; i++) {
                            $scope.editAccountList[i].show = $scope.editAccountList[i].userName === userName;
                        }
                        $scope.editAccountListStateBusy = false;
                    }
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchAccount(' + userName + ') end');
                };
            }
        };
    }]);
//# sourceMappingURL=admin-chargify-message-billing.js.map